'use strict'

angular.module('rmGroups')
    .controller('GroupOverviewCtrl', require('./groups_overview_ctrl'))
    .controller('GroupsFormCtrl', require('./groups_form_ctrl'))
